/**
 * Calendar
 *  Googleカレンダーの連携や、日程管理等の処理を行う。
 */
import calendar from '../../api/calendar'
import moment   from 'moment'
import _        from 'lodash'
import { getUserCalendarColor } from '@/functions/balloonFunc'
import colorList from '@/assets/json/master/color.json'

const EVENT_TIME = 60

export default {
  namespaced: true,
  state: {
    isGoogleAuth: false,
    isGaroonAuth: false,
    isCybozuAuth: false,
    isMSOfficeAuth: false,
    events: [],
    isClickRecommend: false,
    isCalculatedRecommend: false,
    isReadSchedule: false,
    isRecommendSchedule: false,
    isRecommendScheduleLoading: false,
    isErrorRecommendSchedule: false,
    recommendDate: [],
    recommendDateBfr: [],
    recommendDateAft: [],
    schedule: [],
    google_schedule: [],
    garoon_schedule: [],
    cybozu_schedule: [],
    msoffice_schedule: [],
    preserveSuggestedSchedulesList: [],
    schedules: [],
    userData: [],
    isScheduleLoading: false,
    isScheduleAllLoading: false,
    eventFiles: [],
    eventFileGroup: [],
    eventGroup: [],
    isCalendarActionLoading: false,
    temporaryEvents: []
  },
  actions: {
    async getSchedules ({commit}, data) {
      commit('LOAD_SCHEDULES', true)
      try {
        const res = await calendar.getSchedules(data)
        commit('GET_SCHEDULES', res.data)
        commit('LOAD_SCHEDULES', false)
      } catch(e){
        console.error(e)
        commit('LOAD_SCHEDULES', false)
      }
    },
    // ユーザー指定ゲット
    getSchedulesOne ({commit}, data) {
      return calendar.getSchedulesOne(data)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
        })
    },
    createSchedules ({commit}, data) {
      commit('LOAD_SCHEDULES', true)      // カレンダーを読み込み中にする
      commit('LOAD_ALL_SCHEDULES', false) // 全カレンダー(他ユーザー含む)再読み込みフラグ
      return calendar.createSchedules(data)
        .then((d) => {
          commit('LOAD_SCHEDULES', false)
          commit('CREATE_SCHEDULES', d.data)
          return d.data
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          commit('LOAD_ALL_SCHEDULES', true)
          commit('LOAD_SCHEDULES', false)
        })
    },
    updateSchedules ({commit}, data) {
      commit('LOAD_SCHEDULES', true)      // カレンダーを読み込み中にする
      commit('LOAD_ALL_SCHEDULES', false) // 全カレンダー(他ユーザー含む)再読み込みフラグ
      calendar.updateSchedules(data)
        .then((d) => {
          d.data.type='updated'
          commit('UPDATE_SCHEDULES', d.data)
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          commit('LOAD_ALL_SCHEDULES', true)
          commit('LOAD_SCHEDULES', false)
        })
    },
    // 使われていないのでコメントアウト
    // deleteSchedules ({commit}, data) {
    //   commit('LOAD_SCHEDULES', true)
    //   calendar.deleteSchedules(data)
    //     .then((d) => {
    //       commit('LOAD_SCHEDULES', false)
    //       commit('UPDATE_SCHEDULES', d.data)
    //     })
    //     .catch((e) => {
    //       console.error(e)
    //       commit('LOAD_SCHEDULES', false)
    //     })
    // },
    getGoogleCalendar ({commit}) {
      console.debug('*** Start *** getGoogleCalendar')
      commit('GET_GOOGLE_CALENDAR')
      console.debug('*** End *** getGoogleCalendar') 
    },
    getGaroonCalendar ({commit}) {
      console.debug('*** Start *** getGaroonCalendar')
      commit('GET_GAROON_CALENDAR')
      console.debug('*** End *** getGaroonCalendar') 
    },
    getGybozuCalendar ({commit}) {
      commit('GET_CYBOZU_CALENDAR')
    },
    getMSOfficeCalendar ({commit}) {
      commit('GET_MSOFFICE_CALENDAR')
    },
    googleAuthRedirect ({commit}, {email, username}) {
      console.debug('*** Start *** googleAuthRedirect') 
      console.debug('email: ' + JSON.stringify(email))
      console.debug('username: ' + JSON.stringify(username))
      commit('GOOGLE_AUTH_REDIRECT', {email, username})
      console.debug('*** End *** googleAuthRedirect') 
    },
    startRecommendDate ({commit}) {
      console.debug('*** Start *** startRecommendDate') 
      commit('START_RECOMMEND_DATE')
      console.debug('*** End *** startRecommendDate') 
    },
    endRecommendDate ({commit}) {
      console.debug('*** Start *** endRecommendDate') 
      commit('END_RECOMMEND_DATE')
      console.debug('*** End *** endRecommendDate') 
    },
    addEvent ({commit}, {createdSchedule}) {
      console.debug('*** Start *** addEvent') 
      console.debug('createdSchedule: ' + JSON.stringify(createdSchedule))
      commit('ADD_EVENT', {createdSchedule})
      console.debug('*** End *** addEvent') 
    },
    updateEvent ({commit}, data) {
      console.debug('*** Start *** updateEvent') 
      console.debug('data: ' + JSON.stringify(data))
      commit('UPDATE_EVENT', data)
      console.debug('*** End *** updateEvent') 
    },
    removeEvent ({commit}, data) {
      console.debug('*** Start *** removeEvent') 
      console.debug('data: ' + JSON.stringify(data))
      commit('REMOVE_EVENT', data)
      console.debug('*** End *** removeEvent') 
    },
    getSchedule ({commit}, {companyHash, email}) {
      console.debug('*** Start *** getSchedule') 
      console.debug('companyHash: ' + JSON.stringify(companyHash))
      console.debug('email: ' + JSON.stringify(email))
      commit('GET_SCHEDULE', {companyHash, email})
      console.debug('*** End *** getSchedule') 
    },
    updateSchedule ({commit}, {updatedSchedule}) {
      console.debug('*** Start *** updateSchedule')
      console.debug('updatedSchedule: ' + JSON.stringify(updatedSchedule))
      commit('UPDATE_SCHEDULE', {updatedSchedule})
      console.debug('*** End *** updateSchedule')
    },
    setSchedule ({commit}, data) {
      console.debug('*** Start *** setSchedule')
      console.debug('data: ' + JSON.stringify(data))
      commit('SET_SCHEDULE', data)
      console.debug('*** End *** setSchedule')
    },
    deleteSchedule ({commit}, {deletedSchedule}) {
      console.debug('*** Start *** deleteSchedule')
      console.debug('deletedSchedule: ' + JSON.stringify(deletedSchedule))
      commit('DELETE_SCHEDULE', {deletedSchedule})
      console.debug('*** End *** deleteSchedule')
    },
    changeGoogleAuth ({commit}) {
      console.debug('*** Start *** changeGoogleAuth')
      commit('CHANGE_GOOGLE_AUTH')
      console.debug('*** End *** changeGoogleAuth')
    },
    changeMSOfficeAuth ({commit}) {
      console.debug('*** Start *** changeMSOfficeAuth')
      commit('CHANGE_MSOFFICE_AUTH')
      console.debug('*** End *** changeMSOfficeAuth')
    },
    getRecommendDate ({commit}) {
      console.debug('*** Start *** getRecommendDate')
      commit('GET_RECOMMEND_DATE')
      console.debug('*** End *** getRecommendDate')
    },
    async autoCreateSchedule ({commit}, data) {
      console.log('=== autoCreateSchedule Vuexアクション デバッグ開始 ===')
      console.log('送信データ:', data)
      console.log('scenario_param:', data.scenario_param)
      console.log('リマインド関連パラメータ:', {
        reminder_flg: data.scenario_param && data.scenario_param.reminder_flg,
        is_remind: data.scenario_param && data.scenario_param.is_remind,
        remind_time: data.scenario_param && data.scenario_param.remind_time,
        remind_mail: data.scenario_param && data.scenario_param.remind_mail
      })
      
      commit('LOAD_SCHEDULES', true)      // カレンダーを読み込み中にする
      commit('LOAD_ALL_SCHEDULES', false) // 全カレンダー(他ユーザー含む)再読み込みフラグ
      return await calendar.autoCreateSchedule(data)
        .then((d) => {
          console.log('autoCreateSchedule API成功:', d.data)
          commit('AUTO_CREATE_SCHEDULE', d.data)
          return d.data
        })
        .catch((e) => {
          console.error('autoCreateSchedule APIエラー:')
          console.error('e: ' + JSON.stringify(e))
          console.error('レスポンスデータ:', e.response && e.response.data)
          console.error('ステータスコード:', e.response && e.response.status)
          if (e.response.status === 404) {
            throw e.response.data
          }
          throw "Error"
        })
        .finally(() => {
          commit('LOAD_ALL_SCHEDULES', true)
          commit('LOAD_SCHEDULES', false)
        })
    },
    initRecommendSchedule ({commit}) {
      commit('INIT_REC_SCE')
    },
    getRecommendSchedule ({commit}, data) {
      console.debug('*** Start *** getRecommendSchedule')
      console.debug('data: ' + JSON.stringify(data))
      console.debug('Calendar Action - Request Data:', data)  // 追加
      commit('GET_REC_SCE', data)
      console.debug('*** End *** getRecommendSchedule')
    },
    setSuggestedSchedules ({commit}, suggestedSchedules) {
      commit('SET_SUGGESTED_SCHEDULES', suggestedSchedules)
    },
    preserveSuggestedSchedules ({commit}, {suggestedSchedules, targetID}) {
      commit('PRESERVE_SUGGESTED_SCHEDULES', {suggestedSchedules, targetID})
    },
    restoreSuggestedSchedules ({commit}, targetID) {
      commit('RESTORE_SUGGESTED_SCHEDULES', targetID)
    },
    resetSuggestedSchedules ({commit}, targetID) {
      commit('RESET_SUGGESTED_SCHEDULES', targetID)
    },
    async createEventFile ({commit}, data) {
      return await calendar.createEventFile(data)
        .then((d) => {
          commit('CREATE_EF', JSON.parse(d.data))
          return JSON.parse(d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    createEventFileFromTask ({commit}, data) {
      return calendar.createEventFileFromTask(data)
        .then((d) => {
          commit('CREATE_EF', JSON.parse(d.data))
          return JSON.parse(d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getEventFile ({commit}, id) {
      calendar.getEventFile(id)
        .then((d) => {
          commit('GET_EF', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateEventFile ({commit}, data) {
      calendar.updateEventFile(data)
        .then((d) => {
          commit('UPDATE_EF', JSON.parse(d.data))
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteEventFile ({commit}, id) {
      calendar.deleteEventFile(id)
        .then(() => {
          commit('DELETE_EF', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // EventFileGroup API
    createEventFileGroup ({commit}, data) {
      calendar.createEventFileGroup(data)
        .then((d) => {
          commit('CREATE_EFG', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getEventFileGroup ({commit}, id) {
      calendar.getEventFileGroup(id)
        .then((d) => {
          commit('GET_EFG', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateEventFileGroup ({commit}, data) {
      calendar.updateEventFileGroup(data)
        .then((d) => {
          commit('UPDATE_EFG', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteEventFileGroup ({commit}, id) {
      calendar.deleteEventFileGroup(id)
        .then((d) => {
          commit('DELETE_EFG', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getCalendarEvent({ commit }, data) {
      return calendar.getCalendarEvent(data).then((d) => {
        return d
      })
    },
    // EventGroup API
    createEventGroup ({commit, rootState}, data) {
      calendar.createEventGroup(data)
        .then((d) => {
          if (rootState.auth.user.userHash == d.data.user) commit('CREATE_EG', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getEventGroup ({commit}, id) {
      calendar.getEventGroup(id)
        .then((d) => {
          commit('GET_EG', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateEventGroup ({commit}, data) {
      calendar.updateEventFileGroup(data)
        .then((d) => {
          commit('UPDATE_EG', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteEventGroup ({commit}, id) {
      calendar.deleteEventGroup(id)
        .then((d) => {
          commit('DELETE_EG', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // スケジュール送付＋仮候補日時作成
    sendScheduleEmail ({commit}, data) {
      calendar.sendScheduleEmail(data)
        .then((d) => {
          if (data.method === 1) {
            commit('SENDED_SCHEDULE', d.data)
          }
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getTemporaryEvent ({commit}, id) {
      commit('LOAD_ACTION', true)
      calendar.getTemporaryEvent(id)
        .then((d) => {
          commit('GET_TEMP_EVENT', d.data)
          commit('LOAD_ACTION', false)
        })
        .catch((e) => {
          console.error(e)
          commit('LOAD_ACTION', false)
          alert('エラーが発生いたしました。')
        })
    },
    createAndDeleteEvent ({commit}, data) {
      calendar.createAndDeleteEvent(data)
        .then((d) => {
          alert('正式な設定が完了しました。\nこのページを閉じます。')
          window.close()
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生しました。\nこのページを閉じます。')
          window.close()
        })
    },
    getEventFromScenarioAny ({commit}, id) {
      return calendar.getEventFromScenarioAny(id)
        .then((d) => {
          return JSON.parse(d.data)
        })
        .catch((e) => {
        })
    },
    updateEventFromScenarioAny ({commit}, data) {
      return calendar.updateEventFromScenarioAny(data)
        .then((d) => {
          return d
        })
        // .catch((e) => {
        //   console.error(e)
        //   alert('エラーが発生しました。\n大変申し訳ございませんが、もう一度やり直してください。\nこのページを閉じます。')
        //   window.close()
        // })
    },
    async addEventFromScenarioAny ({commit}, data) {
      return await calendar.addEventFromScenarioAny(data)
        .catch((e) => {
          console.error(e)
        })
    },
    deleteEventFromScenarioAnyExtra ({commit}, data) {
      return calendar.deleteEventFromScenarioAnyExtra(data)
        .then((d) => {
          if(d.data) {
             return JSON.parse(d.data)
          } else {
            return d.data
          }
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生しました。\n大変申し訳ございませんが、もう一度やり直してください。\nこのページを閉じます。')
          window.close()
        })
    },
    updateEventScenarios ({commit}, data) {
      return calendar.updateEventScenarios(data)
      .then((d) => {
        return d.data
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生しました。\n大変申し訳ございませんが、もう一度やり直してください。\nこのページを閉じます。')
        window.close()
      })
    },
    deleteEventScenarios ({commit}, id) {
      return calendar.deleteEventScenarios(id)
      .then((d) => {
        return d.data
      })
      .catch((e) => {
        console.error(e)
        alert('エラーが発生しました。\n大変申し訳ございませんが、もう一度やり直してください。\nこのページを閉じます。')
        window.close()
      })
    },
    getReminderFromSeeker ({commit}, id) {
      return calendar.getReminderFromSeeker(id)
        .then((d) => {
          return d.data.reminder_data
        })
        .catch((e) => {
          console.error(e)
          alert('リマインダの情報を取得できませんでした。\nこのページを閉じます。')
          window.close()
        })
    },
    registReminderFromSeeker ({commit}, {id, param}) {
      return calendar.registReminderFromSeeker(id, param)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生しました。\n大変申し訳ございませんが、もう一度やり直してください。\nこのページを閉じます。')
          window.close()
        })
    },
    deleteReminderFromSeeker ({commit}, param) {
      return calendar.deleteReminderFromSeeker(param)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生しました。\n大変申し訳ございませんが、もう一度やり直してください。\nこのページを閉じます。')
          window.close()
        })
    },
    getGoogleDriveAttachmentInfo ({commit}) {
      return calendar.getGoogleDriveAttachmentInfo()
        .then((d) => {
          let drive_info = null
          if (d.data) {
            drive_info = JSON.parse(d.data)
            drive_info['id'] = String(drive_info['id'])
          }
          return drive_info
        })
        .catch((e) => {
          console.error(e)
          return 
        })
    },
    createGoogleDriveAttachmentInfo ({commit}, data) {
      return calendar.createGoogleDriveAttachmentInfo(data)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
        })
    },
    updateGoogleDriveAttachmentInfo ({commit}, data) {
      return calendar.updateGoogleDriveAttachmentInfo(data)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
        })
    },
    createGoogleDriveAttachmentFile ({commit}, data) {
      return calendar.createGoogleDriveAttachmentFile(data)
        .then((d) => {
          return JSON.parse(d.data)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    updateGoogleCalendarAttachmentFile ({commit}, data) {
      return calendar.updateGoogleCalendarAttachmentFile(data)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
        })
    },
    deleteNoLinkageCalendars({commit}, data) {
      return calendar.deleteNoLinkageCalendars(data)
      .then((d) => {
        return d.data
      })
      .catch((e) => {
        console.error(e)
      })
    },
    importSchedule ({commit}, data) {
      commit('LOAD_ALL_SCHEDULES', false)
      return calendar.importSchedule(data)
        .then((d) => {
          alert('インポートを完了いたしました。')
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('インポートに失敗いたしました。\nしばらくしてからのアクセスをお願いいたします。')
        })
        .finally(() => {
          commit('LOAD_ALL_SCHEDULES', true)
        })
    },
  },
  mutations: {
    GET_SCHEDULES (state, data) {
      // 同一外部カレンダーで、他ユーザーを招待するとIDが同じになるため、重複除外は行わない
      // if (state.schedules.length > 0) {
      //   state.schedules = _.unionBy(state.schedules, data.schedules, 'id')
      // } else {
      //   state.schedules = data.schedules
      // }
      state.schedules = data.schedules
      state.userData = data.user_data
    },
    CREATE_SCHEDULES (state, data) {
      state.schedules.push(data)
    },
    UPDATE_SCHEDULES (state, data) {
      for (const i in state.schedules) {
        if (state.schedules[i].id === data.id) {
          if(data.type==='updated'){
            state.schedules.splice(i, 1, data)
          }else if(data.type==='deleted'){
            state.schedules.splice(i, 1)
          }
        }
      }
    },
    LOAD_SCHEDULES (state, flg) {
      state.isScheduleLoading = flg
    },
    LOAD_ALL_SCHEDULES (state, flg) {
      state.isScheduleAllLoading = flg
    },
    GOOGLE_AUTH_REDIRECT (state, {email, username}) {
      console.debug('*** Start *** GOOGLE_AUTH_REDIRECT')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('email: ' + JSON.stringify(email))
      console.debug('username: ' + JSON.stringify(username))
      var uri = process.env.OWN_ENDPOINT
      // localhost の時は切り替える
      if (uri === 'http://localhost:8080') uri = 'http://localhost:8000'
      const params = '/api/user/google_auth?email=' + email + '&username=' + username
      location.href = uri + params
      console.debug('*** End *** GOOGLE_AUTH_REDIRECT')
    },
    IS_GOOGLE_AUTH (state, {email, username}) {
      console.debug('*** Start *** IS_GOOGLE_AUTH')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('email: ' + JSON.stringify(email))
      console.debug('username: ' + JSON.stringify(username))
      // set true or false with django server
      console.debug('*** End *** IS_GOOGLE_AUTH')
    },
    GET_GOOGLE_CALENDAR (state) {
      console.debug('*** Start *** GET_GOOGLE_CALENDAR')
      state.google_schedule = []
      state.isReadSchedule = true
      calendar.getGoogleCalendar()
        .then((d) => {
          console.debug('*** Start *** getGoogleCalendar callback')
          if (d.data.status == null) {
            for (var i in d.data) {
              state.google_schedule.push(d.data[i])
            }
            state.isGoogleAuth = true
            state.isReadSchedule = false
          } else {
            state.isGoogleAuth = false
            state.isReadSchedule = false
          }
          console.debug('*** End *** getGoogleCalendar callback')
        })
      console.debug('*** Start *** GET_GOOGLE_CALENDAR')
    },
    GET_GAROON_CALENDAR (state) {
      console.debug('*** Start *** GET_GAROON_CALENDAR')
      state.garoon_schedule = []
      state.isReadSchedule = true
      calendar.getGaroonCalendar()
        .then((d) => {
          console.debug('*** Start *** getGaroonCalendar callback')
          if (d.data.status == null) {
            for (var i in d.data) {
              state.garoon_schedule.push(d.data[i])
            }
            state.isGaroonAuth = true
            state.isReadSchedule = false
          } else {
            state.isGaroonAuth = false
            state.isReadSchedule = false
          }
          console.debug('*** End *** getGaroonCalendar callback')
        })
      console.debug('*** Start *** GET_GAROON_CALENDAR')
    },
    GET_CYBOZU_CALENDAR (state) {
      state.isReadSchedule = true
      calendar.getCybozuCalendar()
        .then((d) => {
          if (d.data.status == 'ok') {
            state.isCybozuAuth = true
            state.isReadSchedule = false
          } else {
            state.isCybozuAuth = false
            state.isReadSchedule = false
          }
        })
    },
    GET_MSOFFICE_CALENDAR (state) {
      console.debug('*** Start *** GET_MSOFFICE_CALENDAR')
      state.msoffice_schedule = []
      state.isReadSchedule = true
      // TODO: 一旦StateにAPI書いているが、今後修正
      calendar.getMSOfficeCalendar()
        .then((d) => {
          console.debug('*** Start *** getMSOfficeCalendar callback')
          if (d.data.status == null) {
            for (var i in d.data) {
              state.msoffice_schedule.push(d.data[i])
            }
            state.isMSOfficeAuth = true
            state.isReadSchedule = false
          } else {
            state.isMSOfficeAuth = false
            state.isReadSchedule = false
          }
          console.debug('*** End *** getMSOfficeCalendar callback')
        })
      console.debug('*** Start *** GET_MSOFFICE_CALENDAR')
    },
    // スケジュールを作成
    ADD_EVENT (state, {createdSchedule}) {
      console.debug('*** Start *** ADD_EVENT')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('createdSchedule: ' + JSON.stringify(createdSchedule))
      createdSchedule['scheduleId'] = createdSchedule['id']
      if (state.isGoogleAuth) {
        calendar.createGoogleCalendar(createdSchedule)
          .then((d) => {
            console.debug('*** Start *** createGoogleCalendar callback')
            console.debug('d: ' + JSON.stringify(d))
            state.google_schedule.push(d.data)
            console.debug('*** End *** createGoogleCalendar callback')
          })
          .catch((e) => {
            console.debug('*** Start *** createGoogleCalendar error callback')
            console.error('e: ' + JSON.stringify(e))
            console.debug('*** End *** createGoogleCalendar error callback')
          })
      }
      if (state.isGaroonAuth) {
        calendar.createGaroonCalendar(createdSchedule)
          .then((d) => {
            console.debug('*** Start *** createGoogleCalendar callback')
            console.debug('d: ' + JSON.stringify(d))
            state.garoon_schedule.push(d.data)
            console.debug('*** End *** createGoogleCalendar callback')
          })
          .catch((e) => {
            console.debug('*** Start *** createGoogleCalendar error callback')
            console.error('e: ' + JSON.stringify(e))
            console.debug('*** End *** createGoogleCalendar error callback')
          })
      }
      if (state.isCybozuAuth) {
        calendar.createCybozuCalendar(createdSchedule)
          .then((d) => {
            console.debug('*** Start *** createGoogleCalendar callback')
            console.debug('d: ' + JSON.stringify(d))
            state.cybozu_schedule.push(d.data)
            console.debug('*** End *** createGoogleCalendar callback')
          })
          .catch((e) => {
            console.debug('*** Start *** createGoogleCalendar error callback')
            console.error('e: ' + JSON.stringify(e))
            console.debug('*** End *** createGoogleCalendar error callback')
          })
      }
      if (state.isMSOfficeAuth) {
        calendar.createMSOfficeCalendar(createdSchedule)
          .then((d) => {
            console.debug('*** Start *** createGoogleCalendar callback')
            console.debug('d: ' + JSON.stringify(d))
            state.msoffice_schedule.push(d.data)
            console.debug('*** End *** createGoogleCalendar callback')
          })
          .catch((e) => {
            console.debug('*** Start *** createGoogleCalendar error callback')
            console.error('e: ' + JSON.stringify(e))
            console.debug('*** End *** createGoogleCalendar error callback')
          })
      }
      calendar.createSchedule(createdSchedule)
          .then((d) => {
              console.debug('*** Start *** createSchedule callback')
              console.debug('d: ' + JSON.stringify(d))
              state.schedule.push(d.data)
              console.debug('*** End *** createSchedule callback')
            })
          .catch((e) => {
            console.debug('*** Start *** createSchedule error callback')
            console.error('e: ' + JSON.stringify(e))
            console.debug('*** End *** createSchedule error callback')
        })
      console.debug('*** End *** ADD_EVENT')
    },
    AUTO_CREATE_SCHEDULE (state, data) {
      state.schedule.push(data)
    },
    START_RECOMMEND_DATE (state) {
      console.log('###START_RECOMMEND_DATE:')
      console.debug('*** Start *** START_RECOMMEND_DATE')
      console.debug('state: ' + JSON.stringify(state))
      state.isClickRecommend = true
      state.isCalculatedRecommend = false
      // 今日から前の日付は切り捨て
      var today = new Date()
      // 日程入れ込み
      // var makeData = state.schedule.filter(function (item, i) {
      //   if (item.status !== 'cancelled') return true
      // })
      var makeData = state.schedule
      // 日付リコメンド
      for (var i = 1; i < 15; i++) {
        var nextDay = new Date(new Date().setDate(new Date().getDate() + i + 1))
        today = new Date(new Date().setDate(new Date().getDate() + i))
        var yyyy = today.getFullYear()
        var mm = today.getMonth()
        var dd = today.getDate()
        var yyyyNext = nextDay.getFullYear()
        var mmNext = nextDay.getMonth()
        var ddNext = nextDay.getDate()
        var isToday = new Date(yyyy, mm, dd, 0, 0, 0)
        var isNextday = new Date(yyyyNext, mmNext, ddNext, 0, 0, 0)
        var hhStart, hhEnd

        var todayEvents = makeData.filter(function (item, i) {
          if (new Date(item.start).getTime() > new Date(isToday).getTime() && new Date(item.start).getTime() < new Date(isNextday).getTime()) return true
        })
        // 土日の場合は次へs
        if (today.getDay() === 0 || today.getDay() === 6) continue

        // 該当日にイベントがない場合はランダムに予定を入れる。
        if (Object.keys(todayEvents).length === 0) {
          var timetable = [9, 10, 11, 13, 14, 15, 16, 17, 18, 19]
          const random = [
            Math.floor(Math.random() * 2),
            Math.floor(Math.random() * 2) + 3,
            Math.floor(Math.random() * 2) + 6,
            Math.floor(Math.random() * 2) + 8,  // 追加
            Math.floor(Math.random() * 2) + 10  // 追加
          ]
          for (let j = 0; j < 5; j++) {
            hhStart = timetable[random[j]]
            hhEnd = hhStart + 1
            var startDate = yyyy + '/' + (mm + 1) + '/' + dd + ' ' + hhStart + ':' + '00'
            var endDate = hhEnd + ':' + '00'
            state.recommendDate.push({
              'start': startDate,
              'end': endDate
            })
            state.recommendDateBfr.push({
              'start': 0,
              'end': 0
            })
            state.recommendDateAft.push({
              'start': 0,
              'end': 0
            })
            state.isCalculatedRecommend = true
          }
          continue
        }
        // event 1つのみの場合、それ以外に埋め込むがのちほど
        if (Object.keys(todayEvents).length === 1) {
          continue
        } else {
          // イベント判定
          for (var index = 0; index < todayEvents.length - 1; index++) {
            var calcTime = new Date(todayEvents[index + 1].start.dateTime).getTime() - new Date(todayEvents[index].end.dateTime).getTime()
            var hour = new Date(todayEvents[index].end.dateTime).getHours()
            var date = new Date(todayEvents[index].end.dateTime)
            // 分に変換
            calcTime = calcTime / 1000 / 60
            // 4 hour
            // TODO:アルゴリズム最適化すること
            if (calcTime > EVENT_TIME * 4) {
              // 時間が９〜２１時の間で、土日以外
              hhStart = hour + 1
              hhEnd = hhStart + 1
              // ネーミング...
              var hhStartBfr = new Date(todayEvents[index].start.dateTime).getHours()
              var hhEndBfr = new Date(todayEvents[index].end.dateTime).getHours()
              var mmStartBfr = new Date(todayEvents[index].start.dateTime).getMinutes()
              var mmEndBfr = new Date(todayEvents[index].end.dateTime).getMinutes()
              // ネーミング...
              var hhStartAft = new Date(todayEvents[index + 1].start.dateTime).getHours()
              var hhEndAft = new Date(todayEvents[index + 1].end.dateTime).getHours()
              var mmStartAft = new Date(todayEvents[index + 1].start.dateTime).getMinutes()
              var mmEndAft = new Date(todayEvents[index + 1].end.dateTime).getMinutes()
              state.recommendDate.push({
                'start': yyyy + '/' + (mm + 1) + '/' + dd + ' ' + hhStart + ':' + '00',
                'end': hhEnd + ':' + '00'
              })
              state.recommendDateBfr.push({
                'start': yyyy + '/' + (mm + 1) + '/' + dd + ' ' + hhStartBfr + ':' + mmStartBfr,
                'end': hhEndBfr + ':' + mmEndBfr
              })
              state.recommendDateAft.push({
                'start': yyyy + '/' + (mm + 1) + '/' + dd + ' ' + hhStartAft + ':' + mmStartAft,
                'end': hhEndAft + ':' + mmEndAft
              })
              state.isCalculatedRecommend = true
            }
          }
        }
      }
      console.debug('*** End *** START_RECOMMEND_DATE')
    },
    END_RECOMMEND_DATE (state) {
      console.debug('*** Start *** END_RECOMMEND_DATE')
      console.debug('state: ' + JSON.stringify(state))
      state.isClickRecommend = false
      console.debug('*** End *** END_RECOMMEND_DATE')
    },
    REMOVE_EVENT (state, {companyid, projectid, data}) {
      console.debug('*** Start *** REMOVE_EVENT')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('companyid: ' + JSON.stringify(companyid))
      console.debug('projectid: ' + JSON.stringify(projectid))
      console.debug('data: ' + JSON.stringify(data))
      console.debug('*** End *** REMOVE_EVENT')
    },
    GET_SCHEDULE (state, {companyHash, email}) {
      console.debug('*** Start *** GET_SCHEDULE')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('companyHash: ' + JSON.stringify(companyHash))
      console.debug('email: ' + JSON.stringify(email))
      var calendarId = email + '_' + companyHash
      calendar.getSchedule(companyHash, email)
        .then((d) => {
          console.debug('*** Start *** getSchedule callback')
          console.debug('d: ' + JSON.stringify(d))
          state.schedule = []
          for (var i in d.data) {
            var schedule = {
              id: d.data[i].scheduleId,
              companyHash: d.data[i].company_hash,
              email: d.data[i].email,
              calendarId: d.data[i].calendarId,
              category: d.data[i].category,
              // title: d.data[i].title,
              title: d.data[i].calendarId !== calendarId ? '予定あり' : d.data[i].title,
              location: d.data[i].location,
              start: d.data[i].start,
              end: d.data[i].end,
              isAllDay: d.data[i].isAllDay,
              state: d.data[i].state,
              bgColor: getUserCalendarColor(d.data[i].className.replace('class-', ''), state.calendarSettings, colorList, state.selfUser && state.selfUser.userHash),
              dragBgColor: getUserCalendarColor(d.data[i].className.replace('class-', ''), state.calendarSettings, colorList, state.selfUser && state.selfUser.userHash),
              borderColor: getUserCalendarColor(d.data[i].className.replace('class-', ''), state.calendarSettings, colorList, state.selfUser && state.selfUser.userHash),
              isVisible: d.data[i].isVisible,
              isPrivate: d.data[i].isPrivate,
              isReadOnly: d.data[i].calendarId !== calendarId
            }
            state.schedule.push(schedule)
          }
          console.debug('*** End *** getSchedule callback')
        })
        .catch((e) => {
          console.log('GET FAILED' + JSON.stringify(e))
        })
      console.debug('*** End *** GET_SCHEDULE')
    },
    UPDATE_SCHEDULE (state, {updatedSchedule}) {
      console.debug('*** Start *** UPDATE_SCHEDULE')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('updatedSchedule: ' + JSON.stringify(updatedSchedule))
      updatedSchedule['scheduleId'] = updatedSchedule['id']
      // Googleカレンダーと連携済の場合はそちらにも連携する
      if (state.isGoogleAuth) {
        for (var s in state.google_schedule) {
          if (state.google_schedule[s].id === updatedSchedule['id']) {
            updatedSchedule['gcid'] = state.google_schedule[s].id
          } else if (state.google_schedule[s].scheduleId === updatedSchedule['id']) {
            updatedSchedule['gcid'] = state.google_schedule[s].gcid
          }
        }
        calendar.updateGoogleCalendar(updatedSchedule)
          .then((d) => {
            console.debug('*** Start *** updateGoogleCalendar callback')
            console.debug('d: ' + JSON.stringify(d))
            console.debug('*** End *** updateGoogleCalendar callback')
          })
          .catch((e) => {
            console.debug('*** Start *** updateGoogleCalendar error callback')
            console.error('e: ' + JSON.stringify(e))
            console.debug('*** End *** updateGoogleCalendar error callback')
          })
      }
      // Garoonカレンダーと連携済の場合はそちらにも連携する
      if (state.isGaroonAuth) {
        for (var s in state.garoon_schedule) {
          if (state.garoon_schedule[s].id === updatedSchedule['id']) {
            updatedSchedule['grid'] = state.garoon_schedule[s].id
          } else if (state.garoon_schedule[s].scheduleId === updatedSchedule['id']) {
            updatedSchedule['grid'] = state.garoon_schedule[s].grid
          }
        }
        calendar.updateGaroonCalendar(updatedSchedule)
          .then((d) => {
            console.debug('*** Start *** updateGoogleCalendar callback')
            console.debug('d: ' + JSON.stringify(d))
            console.debug('*** End *** updateGoogleCalendar callback')
          })
          .catch((e) => {
            console.debug('*** Start *** updateGoogleCalendar error callback')
            console.error('e: ' + JSON.stringify(e))
            console.debug('*** End *** updateGoogleCalendar error callback')
          })
      }
      // CybozuOfficeカレンダーと連携済の場合はそちらにも連携する
      if (state.isCybozuAuth) {
        calendar.updateCybozuCalendar(updatedSchedule)
          .then((d) => {
            console.debug('*** Start *** updateGoogleCalendar callback')
            console.debug('d: ' + JSON.stringify(d))
            console.debug('*** End *** updateGoogleCalendar callback')
          })
          .catch((e) => {
            console.debug('*** Start *** updateGoogleCalendar error callback')
            console.error('e: ' + JSON.stringify(e))
            console.debug('*** End *** updateGoogleCalendar error callback')
          })
      }
      // MSOfficeカレンダーと連携済の場合はそちらにも連携する
      if (state.isMSOfficeAuth) {
        calendar.updateMSOfficeCalendar(updatedSchedule)
          .then((d) => {
            console.debug('*** Start *** updateMSOfficeCalendar callback')
            console.debug('d: ' + JSON.stringify(d))
            console.debug('*** End *** updateMSOfficeCalendar callback')
          })
          .catch((e) => {
            console.debug('*** Start *** updateMSOfficeCalendar error callback')
            console.error('e: ' + JSON.stringify(e))
            console.debug('*** End *** updateMSOfficeCalendar error callback')
          })
      }
      calendar.updateSchedule(updatedSchedule)
          .then((d) => {
            console.debug('*** Start *** updateSchedule callback')
            console.debug('d: ' + JSON.stringify(d))
            console.debug('*** End *** updateSchedule callback')
          })
          .catch((e) => {
            console.debug('*** Start *** updateSchedule error callback')
            console.error('e: ' + JSON.stringify(e))
            console.debug('*** End *** updateSchedule error callback')
          })
      console.debug('*** End *** UPDATE_SCHEDULE')
    },
    SET_SCHEDULE (state, data) {
      console.debug('*** Start *** SET_SCHEDULE')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('data: ' + JSON.stringify(data))
      state.selected.title = data.title
      // String->Dateへの型変換
      state.selected.date = new Date(data.date)
      state.selected.startTime = new Date(data.startTime)
      state.selected.endTime = new Date(data.endTime)
      state.selected.pk = data.pk
      state.selected.isdelete = data.isdelete
      state.selected.email = data.email
      console.debug('*** End *** SET_SCHEDULE')
    },
    DELETE_SCHEDULE (state, {deletedSchedule}) {
      console.debug('*** Start *** DELETE_SCHEDULE')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('deletedSchedule: ' + JSON.stringify(deletedSchedule))
      var gcid = ''
      deletedSchedule['scheduleId'] = deletedSchedule['id']
      // Googleカレンダーと連携済の場合はそちらにも連携する
      if (state.isGoogleAuth) {
        for (var s in state.google_schedule) {
          if (state.google_schedule[s].id === deletedSchedule['id']) {
            gcid = state.google_schedule[s].id
          } else if (state.google_schedule[s].scheduleId === deletedSchedule['id']) {
            gcid = state.google_schedule[s].gcid
          }
        }
        if (gcid != '') {
          calendar.deleteGoogleCalendar(gcid)
            .then((d) => {
              console.debug('*** Start *** deleteGoogleCalendar callback')
              console.debug('d: ' + JSON.stringify(d))
              console.debug('*** End *** deleteGoogleCalendar callback')
            })
            .catch((e) => {
              console.debug('*** Start *** deleteGoogleCalendar error callback')
              console.error('e: ' + JSON.stringify(e))
              console.debug('*** End *** deleteGoogleCalendar error callback')
            })
        }
      }
      // Garoonカレンダーと連携済の場合はそちらにも連携する
      if (state.isGaroonAuth) {
        if (deletedSchedule['id'] != '') {
          calendar.deleteGaroonCalendar(deletedSchedule['id'])
            .then((d) => {
              console.debug('*** Start *** deleteGoogleCalendar callback')
              console.debug('d: ' + JSON.stringify(d))
              console.debug('*** End *** deleteGoogleCalendar callback')
            })
            .catch((e) => {
              console.debug('*** Start *** deleteGoogleCalendar error callback')
              console.error('e: ' + JSON.stringify(e))
              console.debug('*** End *** deleteGoogleCalendar error callback')
            })
        }
      }
      // CybozuOfficeカレンダーと連携済の場合はそちらにも連携する
      if (state.isCybozuAuth) {
        if (deletedSchedule['id'] != '') {
          calendar.deleteCybozuCalendar(deletedSchedule['id'])
            .then((d) => {
              console.debug('*** Start *** deleteGoogleCalendar callback')
              console.debug('d: ' + JSON.stringify(d))
              console.debug('*** End *** deleteGoogleCalendar callback')
            })
            .catch((e) => {
              console.debug('*** Start *** deleteGoogleCalendar error callback')
              console.error('e: ' + JSON.stringify(e))
              console.debug('*** End *** deleteGoogleCalendar error callback')
            })
        }
      }
      // MSOff]iceカレンダーと連携済の場合はそちらにも連携する
      if (state.isMSOfficeAuth) {
        if (deletedSchedule['id'] != '') {
          calendar.deleteMSOfficeCalendar(deletedSchedule['id'])
            .then((d) => {
              console.debug('*** Start *** deleteMSOfficeCalendar callback')
              console.debug('d: ' + JSON.stringify(d))
              console.debug('*** End *** deleteMSOfficeCalendar callback')
            })
            .catch((e) => {
              console.debug('*** Start *** deleteMSOfficeCalendar error callback')
              console.error('e: ' + JSON.stringify(e))
              console.debug('*** End *** deleteMSOfficeCalendar error callback')
            })
        }
      }
      calendar.deleteSchedule(deletedSchedule)
          .then((d) => {
            console.debug('*** Start *** deleteSchedule callback')
            console.debug('d: ' + JSON.stringify(d))
            console.debug('*** End *** deleteSchedule callback')
          })
          .catch((e) => {
            console.debug('*** Start *** deleteSchedule error callback')
            console.error('e: ' + JSON.stringify(e))
            console.debug('*** End *** deleteSchedule error callback')
          })
      console.debug('*** End *** DELETE_SCHEDULE')
    },
    CHANGE_GOOGLE_AUTH (state) {
      console.debug('*** Start *** CHANGE_GOOGLE_AUTH')
      console.debug('state: ' + JSON.stringify(state))
      state.isGoogleAuth = false
      alert('連携を解除しました。再読み込みします。')
      console.debug('*** End *** CHANGE_GOOGLE_AUTH')
    },
    CHANGE_MSOFFICE_AUTH (state) {
      state.isMSOfficeAuth = false
      alert('連携を解除しました。再読み込みします。')
      location.reload()
    },
    GET_RECOMMEND_DATE (state) {
      console.log('###GET_RECOMMEND_DATE:')
      console.debug('*** Start *** GET_RECOMMEND_DATE')
      console.debug('state: ' + JSON.stringify(state))
      state.recommendDate = []
      var day = moment(new Date())
      for (var i = 0; i < 14; i++) {
        if (state.schedule.indexOf(day.format('YYYY-MM-DD') == -1)) {
          state.recommendDate.push(day.format('YYYY-MM-DD'))
        }
        day.add(1, 'days')
      }
      console.info('CHECK RECOMMEND DATE' + JSON.stringify(state.recommendDate))
      console.debug('*** End *** GET_RECOMMEND_DATE')
    },
    INIT_REC_SCE (state) {
      state.isRecommendSchedule = true
      state.isErrorRecommendSchedule = false
      state.isRecommendScheduleLoading = false
      state.recommendDate = {start: 'Initialized', end: 'Initialized'}
    },
    GET_REC_SCE (state, data) {
      console.debug('*** Start *** GET_REC_SCE')
      console.log('###getRecommendSchedule:',data)
      state.isRecommendSchedule = false
      state.isErrorRecommendSchedule = false
      state.isRecommendScheduleLoading = true
      calendar.getRecommendSchedule(data)
        .then((d) => {
          state.isRecommendSchedule = true
          state.isErrorRecommendSchedule = false
          state.isRecommendScheduleLoading = false
          console.debug('*** Start *** getRecommendSchedule callback')
          console.debug('d: ' + JSON.stringify(d))
          state.recommendDate = d.data
          console.debug('*** End *** getRecommendSchedule callback')
        })
        .catch((e) => {
          state.isRecommendSchedule = true
          state.isErrorRecommendSchedule = true
          state.isRecommendScheduleLoading = false
          alert('大変申し訳ございません。\n候補日時をお取りすることができませんでした。\n大変お手数をおかけいたしますが、再読み込みを行い最初からやり直しをお願い致します。')
        })
      console.debug('*** End *** GET_REC_SCE')
    },
    PRESERVE_SUGGESTED_SCHEDULES (state, {suggestedSchedules, targetID}) {
      state.preserveSuggestedSchedulesList.push(suggestedSchedules)
      if (targetID) {
        localStorage.setItem(
          'PRECAL_' + targetID,
          JSON.stringify(state.preserveSuggestedSchedulesList)
        )
      }
    },
    RESTORE_SUGGESTED_SCHEDULES (state, targetID) {
      state.preserveSuggestedSchedulesList.pop()
      if (targetID) {
        localStorage.setItem(
          'PRECAL_' + targetID,
          JSON.stringify(state.preserveSuggestedSchedulesList)
        )
      }
    },
    RESET_SUGGESTED_SCHEDULES (state, targetID) {
      state.preserveSuggestedSchedulesList = []
      if (targetID) {
        localStorage.setItem(
          'PRECAL_' + targetID,
          JSON.stringify(state.preserveSuggestedSchedulesList)
        )
      }
    },
    SET_SUGGESTED_SCHEDULES (state, suggestedSchedules) {
      state.preserveSuggestedSchedulesList = suggestedSchedules
    },
    // EventFile API
    CREATE_EF (state, data) {
      state.eventFiles.push(data)
    },
    GET_EF (state, data) {
      state.eventFiles = data
    },
    UPDATE_EF (state, data) {
      for (let i in state.eventFiles) {
        if (state.eventFiles[i].pk == data.pk) {
          state.eventFiles.splice(i, 1, data)
          return
        }
      }
    },
    DELETE_EF (state, id) {
      for (let i in state.eventFiles) {
        if (state.eventFiles[i].pk == id) {
          state.eventFiles.splice(i, 1)
          return
        }
      }
    },
    // EventFileGroup API
    CREATE_EFG (state, data) {
      state.eventFileGroup.push(data)
    },
    GET_EFG (state, data) {
      state.eventFileGroup = data
    },
    UPDATE_EFG (state, data) {
      for (let i in state.eventFileGroup) {
        if (state.eventFileGroup[i].pk == data.pk) {
          state.eventFileGroup.splice(i, 1, data)
          return
        }
      }
    },
    DELETE_EFG (state, id) {
      for (let i in state.eventFileGroup) {
        if (state.eventFileGroup[i].pk == id) {
          state.eventFileGroup.splice(i, 1)
          return
        }
      }
    },
    // EventGroup API
    CREATE_EG (state, data) {
      state.eventGroup.push(data)
    },
    GET_EG (state, data) {
      state.eventGroup = data
    },
    UPDATE_EG (state, data) {
      for (let i in state.eventGroup) {
        if (state.eventGroup[i].pk == data.pk) {
          state.eventGroup.splice(i, 1, data)
          return
        }
      }
    },
    DELETE_EG (state, id) {
      for (let i in state.eventGroup) {
        if (state.eventGroup[i].pk == id) {
          state.eventGroup.splice(i, 1)
          return
        }
      }
    },
    SENDED_SCHEDULE (state, data) {
      for (const d of data) {
        state.events(data)
      }
    },
    GET_TEMP_EVENT (state, data) {
      state.temporaryEvents = data
    },
    LOAD_ACTION (state, flg) {
      state.isCalendarActionLoading = flg
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/calendar.js